import { useQuery } from 'react-query'
import { getAllServiceOrders } from '../..'
import { PaginatedRequest } from '../../../core/interfaces'
import { CustomersFilter } from '../../../entities'

export default function useServiceOrders(query: PaginatedRequest<any>) {
  const {
    data: serviceOrders,
    error: serviceOrdersError,
    isLoading: serviceOrdersLoading,
    isFetching,
    isPreviousData
  } = useQuery(['serviceOrders', query], () => getAllServiceOrders(query), {
    keepPreviousData: true
  })
  return {
    serviceOrders,
    serviceOrdersError,
    serviceOrdersLoading,
    isFetching,
    isPreviousData
  }
}
